import React from "react";
import SearchBar from "../../../components/header/search-bar/SearchBar";
import AdList from "../../../components/main-layout-components/ad-list/AdList";
import SellerDetails from "../../../components/main-layout-components/seller-details/SellerDetails";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import useApiService from "../../../hooks/useApiService";
import { getSellerProfileById } from "../../../services/main-service/mainService";
import PremiumAdsSlideshow from "../../../components/main-layout-components/premium-ads-slideshow/PremiumAdsSlideshow";
import DisplayAdsSection from "../../../components/main-layout-components/display-ads-section/DisplayAdsSection";
import {
  SELLER_PROFILE_PAGE_ADS_LIMIT,
  SELLER_PROFILE_PAGE_BOOSTED_LIMIT,
  SELLER_PROFILE_PAGE_PREMIUM_LIMIT,
} from "../../../configs/limits/adLimits";
import Spinner from "../../../components/common/spinner/Spinner";
import { decodeWithSalt } from "../../../utils/encodeFunctions";

function SellerProfilePage() {
  const { sellerId } = useParams();
  let [searchParams, setSearchParams] = useSearchParams();
  let page = searchParams.get("page") || "1";
  let categoryType = searchParams.get("categoryType") || "";
  let location = searchParams.get("location") || "";
  let searchTerm = searchParams.get("searchTerm") || "";
  const navigate = useNavigate();

  const payload = {
    ad_limit: SELLER_PROFILE_PAGE_ADS_LIMIT,
    ad_skip: 0 + (Number(page) - 1) * SELLER_PROFILE_PAGE_ADS_LIMIT,
    boosted_ad_limit: SELLER_PROFILE_PAGE_BOOSTED_LIMIT,
    category: categoryType,
    location: location,
    premium_ad_limit: SELLER_PROFILE_PAGE_PREMIUM_LIMIT,
    search_term: searchTerm.replaceAll("+", " "),
    seller_id: decodeWithSalt(sellerId ? sellerId : ""),
  };

  const { data, loading, error } = useApiService({
    serviceCall: () => getSellerProfileById(payload),
    dependencies: [page, searchTerm],
  });

  const handleSearch = (query: string) => {
    navigate({
      pathname: `/seller-profile/${sellerId}`,
      search: `?page=1&searchTerm=${query.replaceAll(" ", "+")}`,
    });
  };

  function handleNextBtn() {
    const newParams: any = {
      page: (Number(page) + 1).toString(),
    };

    if (searchTerm) newParams.searchTerm = searchTerm;

    setSearchParams(newParams);
  }

  function handlePreviousBtn() {
    if (Number(page) - 1 > 0) {
      const newParams: any = {
        page: (Number(page) - 1).toString(),
      };

      if (searchTerm) newParams.searchTerm = searchTerm;

      setSearchParams(newParams);
    }
  }

  if (loading) return <Spinner />;
  if (error) return <p className="text-center">{error}</p>;

  return (
    <div className="p-3 bg-body-secondary container">
      {/* <button className="btn btn-danger btn-sm">Back</button> */}
      {/* <div className="py-3 bg-body-secondary">
          <div className="maximum-width mx-auto bg-white p-2">
            <SellerDetails />
          </div>
        </div> */}
      <div className="bg-white p-2">
        <div className="row">
          <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 border-end">
            <div>
              <div className="cursor-pointer" onClick={() => navigate(-1)}>
                <MdOutlineArrowBackIosNew size={32} color="red" />
              </div>
              {/* <button className="btn btn-danger btn-sm">
                <MdOutlineArrowBackIosNew size={15} />
              </button> */}
              <div className="mt-md-3 mt-0">
                {data?.profile && (
                  <SellerDetails sellerProfile={data?.profile} />
                )}
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-8">
            <div className="m-3 pb-2">
              <div>
                <SearchBar
                  placeholder={`Search Ads from ${data?.profile?.name}`}
                  onSearch={handleSearch}
                />
              </div>
            </div>
            <DisplayAdsSection
              premiumAdList={data?.premium_ads ?? []}
              boostedAdList={data?.boosted_ads ?? []}
              adList={data?.ads ?? []}
              isLastPage={data?.is_ads_last_page ?? false}
              handleNextBtn={handleNextBtn}
              handlePreviousBtn={handlePreviousBtn}
              pageNo={Number(page)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SellerProfilePage;
